<template>
  <div>
    <v-breadcrumbs class="pa-4" :items="breadcrumb" large></v-breadcrumbs>

    <v-card class="pb-4" :loading="loading">
      <v-card-title>
        Informações da Tarefa
      </v-card-title>

      <v-row >
        <v-col md="3" sm="3" xs="4" v-if="getEntityLocation()">
          <v-card-text class="py-0">
            <div class="text--secondary">Local</div>
            <div>
              <a target="_blank" :href="`/location/${getEntityLocation().id}`">{{ getEntityLocation().store_code ? getEntityLocation().store_code + ' - ' : '' }}{{ getEntityLocation().location_name }}</a>
            </div>
          </v-card-text>
        </v-col>

        <v-col md="3" sm="3" xs="4">
          <v-card-text class="py-0">
            <div class="text--secondary">Conta</div>
            <div>{{ get(taskData, 'account_name') }}</div>
          </v-card-text>
        </v-col>

        <v-col md="3" sm="3" xs="4">
          <v-card-text class="py-0">
            <div class="text--secondary">Usuário</div>
            <div>{{ get(taskData, 'user.name') }}</div>
          </v-card-text>
        </v-col>

        <v-col md="3" sm="3" xs="4">
          <v-card-text class="py-0">
            <div class="text--secondary">Data de criação</div>
            <div>{{ get(taskData, 'created_at_formatted') }}</div>
          </v-card-text>
        </v-col>

        <v-col md="3" sm="3" xs="4">
          <v-card-text class="py-0">
            <div class="text--secondary">Tipo</div>
            <div>{{ get(taskData, 'type_formatted') }}</div>
          </v-card-text>
        </v-col>

        <v-col md="3" sm="3" xs="4">
          <v-card-text class="py-0">
            <div class="text--secondary">Ação em massa?</div>
            <div>{{ get(taskData, 'bulk') ? 'Sim' : 'Não' }}</div>
          </v-card-text>
        </v-col>

        <v-col md="3" sm="3" xs="4">
          <v-card-text class="py-0">
            <div class="text--secondary">Agendado para</div>
            <div>{{ get(taskData, 'date_formatted') }}</div>
          </v-card-text>
        </v-col>

        <v-col md="3" sm="3" xs="4">
          <v-card-text class="py-0">
            <div class="text--secondary">Finalizado em</div>
            <div>{{ get(taskData, 'executed_at_formatted') || '-' }}</div>
          </v-card-text>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-btn v-if="taskData.status === 'OK' && get(taskData, 'file_name')" :loading="loadingDownload" class="mt-4 pa-2"
               text small outlined color="primary" @click.prevent="downloadFile('locais.xlsx')">
          Download do arquivo
          <v-icon>mdi-download-outline</v-icon>
        </v-btn>

        <v-btn v-if="task.task_child" class="mt-4 pa-2" small text outlined color="primary" @click="goToChildTask">
          Ver tarefa vinculada
        </v-btn>

        <v-btn v-if="task.task_id" class="mt-4 pa-2"  small text outlined color="primary" @click="goToFatherTask">
          Ver tarefa pai
        </v-btn>

        <v-spacer />

        <template v-if="canManageTasks">
          <action-confirm-modal
            class="mt-4 pa-2"
            action-text="Executar Agora"
            action-color="primary"
            title="Forçar execução da tarefa?"
            description="Isso disparará o comando de execução instantaneamente para os itens pendentes."
            :expected-text="`executar:${id}`"
            :action="() => $store.dispatch('tasks/force', id)"
            :on-success="() => showNotification('Comando de execução enviado!', 'success')"
            small outlined text
          />

          <action-confirm-modal
            v-if="task.type === 'TYPE_CREATE_LOCAL_POST'"
            class="mt-4 pa-2"
            action-text="Forçar Retomada"
            action-color="warning"
            title="Recalcular e Forçar Retomada?"
            description="O sistema vai identificar quais locais ainda não foram postados e forçar a execução apenas para eles (equivalente ao script do Tinker)."
            :expected-text="`forcar:${id}`"
            :action="() => $store.dispatch('tasks/forceResume', id)"
            :on-success="() => showNotification('Processo de retomada iniciado!', 'success')"
            small outlined text
          />

          <action-confirm-modal
            class="mt-4 pa-2"
            action-text="Matar Execução"
            action-color="error"
            title="Matar a execução desta tarefa?"
            description="CUIDADO: Isso tentará interromper o processo PHP associado a esta tarefa."
            :expected-text="`matar:${id}`"
            :action="() => $store.dispatch('tasks/kill', id)"
            :on-success="() => showNotification('Comando para encerrar enviado!', 'info')"
            small outlined text
          />
        </template>

        <confirm-modal
          v-if="!task.task_child && task.type === 'TYPE_CREATE_LOCAL_POST' && taskData.entity && task.entity.id"
          :loading="loadingCreateDeleteTask" text rounded small outlined action-text="Criar tarefa de exclusão"
          action-color="primary" :action="createDeleteTask" title="Tem certeza?"
          description="A tarefa será executada 10 minutos após a criação." />
      </v-card-actions>
    </v-card>

    <v-card v-if="task.id">
      <v-tabs v-model="tab" class="mt-4">
        <v-tab
          v-for="tab in getTabs()"
          v-bind:key="tab.name">
          {{ tab.title }}
          <v-badge v-if="errorsCount > 0 && tab.name === 'errors'" x-small class="mx-2" color="error"
            :content="errorsCount">
          </v-badge>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="py-2 px-1">
        <v-tab-item>
          <v-card-title>
            Status
            <v-chip class="ml-2" small :color="getStatusColor(get(firebaseData, 'status') || get(taskData, 'status'))">
              {{ displayStatus }}
            </v-chip>
          </v-card-title>

          <v-card-subtitle>
            {{ firebaseData.status_message || 'Nenhum log encontrado.' }}
          </v-card-subtitle>

          <div class="text-right px-4" v-if="taskData.bulk">
            <v-progress-linear height="10" rounded :value="getCurrentPercentage()" />
            <small class="text--secondary">{{ getCurrentProgress() }}/{{ getTotalProgress() }}</small>
          </div>

          <v-data-table :page="logPage" v-if="firebaseData.logs && Object.keys(firebaseData.logs).length > 0"
            :headers="statusTableHeaders" :items="logs" item-key="_key" locale="pt-BR" :items-per-page="10" hide-default-footer
            v-on:click:row="clickRow">
            <template v-slot:item.display_name="{ item }">
              <v-btn class="mr-4" text icon :color="item.error ? 'error' : 'success'">
                <v-icon>
                  {{ item.error ? 'mdi-close-circle' : 'mdi-check-circle' }}
                </v-icon>
              </v-btn>
              {{ item.display_name }}
            </template>

            <template v-slot:footer>
              <v-pagination v-model="logPage" :total-visible="6"
                :length="Math.ceil(Object.keys(firebaseData.logs).length / 6)"></v-pagination>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item>
          <v-card-title>Erros</v-card-title>

          <v-card-subtitle v-if="errorsCount === 0">{{ errorMessage }}</v-card-subtitle>

          <v-data-table v-if="errorsLog.length > 0 && errorsCount > 0" :headers="statusTableHeaders" :items="errorsLog" item-key="_key"
            :items-per-page="10" locale="pt-BR" hide-default-footer v-on:click:row="clickRow">
            <template v-slot:item.display_name="{ item }">
              <v-btn class="mr-4" text icon :color="item.error ? 'error' : 'success'">
                <v-icon>
                  {{ item.error ? 'mdi-close-circle' : 'mdi-check-circle' }}
                </v-icon>
              </v-btn>
              {{ item.display_name }}
            </template>

            <template v-slot:footer>
              <v-pagination v-model="errorPage" :total-visible="6"
                :length="Math.floor(errorsLog.length / 6)"></v-pagination>
            </template>
          </v-data-table>
        </v-tab-item>
        
        <v-tab-item v-if="get(taskData, 'entity.id', false) && get(taskData, 'entity_type', '').includes('LocalPost')" class="justify-content-end">
          <location-post :no-action="true" :id="get(taskData, 'entity.id', 0)"
            :title="get(taskData, 'entity.event_title', '')" :summary="get(taskData, 'entity.summary', '')"
            :type="get(taskData, 'entity.topic_type', '')" :action-button-link="get(taskData, 'entity.action_url', '')"
            :action-button-type="get(taskData, 'entity.action_type', '')"
            :created-at="get(taskData, 'entity.create_time_formatted', '')"
            :alert-type="get(taskData, 'entity.alert_type', '')"
            :event-schedule="get(taskData, 'entity.event_schedule_formatted', '')"
            :event-schedule-code="get(taskData, 'entity.event_schedule_code_formatted', '')"
            :offer-coupon-code="get(taskData, 'entity.offer_coupon_code', '')"
            :offer-redeem-online-url="get(taskData, 'entity.offer_redeem_online_url', '')"
            :offer-terms-and-conditions="get(taskData, 'entity.offer_terms_conditions', '')"
            :location-name="get(taskData, 'entity.location_name', '')"
            :location-phone="get(taskData, 'entity.location.primary_phone', '')"
            :open-date="parseDate(get(taskData, 'entity.event_start_date', ''))"
            :open-time="parseTime(get(taskData, 'entity.event_start_date', ''))"
            :close-date="parseDate(get(taskData, 'entity.event_end_date', ''))"
            :close-time="parseTime(get(taskData, 'entity.event_end_date', ''))"
            :background="getBackground(get(taskData, 'entity.media[0].sourceUrl', ''))"
            :media="get(taskData, 'entity.media[0].sourceUrl', '')"
            :media-format="get(taskData, 'entity.media[0].mediaFormat', '')" />
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions v-if="taskData.status === 'WAITING' || taskData.status === 'ERROR'">
        <v-spacer />
        <confirm-modal v-if="taskData.status === 'WAITING'" :loading="loadingCancel"
          action-color="error" action-text="Cancelar" :action="cancelTask" title="Cancelar tarefa"
          description="Tem certeza que deseja cancelar a execução dessa tarefa? Essa ação não poderá ser desfeita."
          :on-success="onCancelTask" text/>
        <v-btn v-if="taskData.status === 'ERROR' && get(taskData, 'file_name')"
          color="error" @click.prevent="downloadFile('task-errors.xlsx')" :loading="loadingExecute" outlined>
          Exportar erros
        </v-btn>

        <div class="ml-2">
          <confirm-modal
            v-if="taskData.status === 'ERROR'"
            action-color="info" action-text="Executar itens com erro"
            :action="executeTask" title="Executar tarefa"
            outlined
            text
          />
        </div>

      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import LocationPost from '@/views/Locations/Components/LocationPost'
import ActionConfirmModal from '@/components/ActionConfirmModal'
import ConfirmModal from '@/components/ConfirmModal'
import { handleResponseError } from '@/api/handleError'
import { CAN_MANAGE_TASKS } from '@/constants/permissions'
import hasPermission from '@/helpers/hasPermission'
import { ref, onValue } from "firebase/database"
import { mapState } from 'vuex'
import { get } from 'lodash'
import { database } from '@/plugins/firebase'
import { STATUS_ERROR, STATUS_OK, STATUS_RUNNING, STATUS_WAITING } from '@/constants/tasks'
import backgroundVideoDefault from '@/assets/video-logodefault.png'

export default {
  name: 'Task',
  computed: {
    ...mapState({
      task: state => state.tasks.task,
      locationsExport: state => state.locations.exportLocations
    }),
    canManageTasks() {
      return hasPermission(CAN_MANAGE_TASKS)
    },
    get() {
      return get
    },
    STATUS() {
      return {
        STATUS_ERROR,
        STATUS_OK,
        STATUS_RUNNING,
        STATUS_WAITING
      }
    },
    // "Na fila": RUNNING no banco mas ainda sem log_tasks (has_started=false) = despachada,
    // porém enfileirada (worker único ocupado) — não executando de fato.
    displayStatus() {
      const apiStatus = get(this.taskData, 'status')
      if (apiStatus === STATUS_RUNNING && get(this.taskData, 'has_started') === false) {
        return 'Na fila'
      }
      return this.getStatusName(get(this.firebaseData, 'status') || apiStatus)
    }
  },
  components: {
    ConfirmModal,
    ActionConfirmModal,
    LocationPost
  },
  methods: {
    getTabs() {
      return this.tabs.filter(t => t.name !== 'local_post' || (t.name === 'local_post'
        && get(this.taskData, 'entity.id', false)
        && get(this.taskData, 'entity_type', '')
          .includes('LocalPost')))
    },
    getEntityLocation() {
      if (this.taskData.entity_type === "App\\Models\\Location" && this.taskData.entity) {
        return this.taskData.entity
      }
      // if (this.taskData.entity_type === "App\\Models\\LocalPost" && this.taskData.entity) {
      //   return this.taskData.entity.location
      // }
    },
    async downloadFile() {
      this.loadingDownload = true
      await this.$store.dispatch('locations/exportLocations', { id: this.task.id }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao gerar o relatório.')
        this.showNotification(message, 'red darken-2')
        this.loadingDownload = false
      })
      this.loadingDownload = false
    },
    clickRow(item) {
      window.open(`/location/${item.id}`)
    },
    goToChildTask: function () {
      window.open('/task/' + this.task.task_child.id)
    },
    goToFatherTask: function () {
      window.open('/task/' + this.task.task_id)
    },
    getTotalProgress() {
      return parseInt(this.firebaseData.total || 0)
    },
    getCurrentProgress() {
      return parseInt(this.firebaseData.progress || 0)
    },
    getCurrentPercentage() {
      return Math.floor((this.getCurrentProgress() * 100) / this.getTotalProgress())
    },
    showNotification(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    getTask: async function (id) {
      this.loading = true
      await this.$store.dispatch('tasks/getTask', id).catch((e) => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar a tarefa.')
        this.showNotification(message, 'red darken-2')
        this.loading = false
      });
      this.loading = false
    },
    getStatusColor(status) {
      status = status || this.taskData.status
      switch (status) {
        case STATUS_OK:
          return 'success';
        case STATUS_ERROR:
          return 'error';
        case STATUS_RUNNING:
          return 'info';
        case STATUS_WAITING:
          return 'warning';
        default:
          return 'info';
      }
    },
    getStatusName(status) {
      switch (status) {
        case STATUS_WAITING:
          return 'Aguardando';
        case STATUS_OK:
          return 'Concluído';
        case STATUS_ERROR:
          return 'Com erro';
        case STATUS_RUNNING:
          return 'Executando';
      }
    },
    async executeTask() {
      this.loadingExecute = true
      await this.$store.dispatch('tasks/rerun', this.id).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao executar a tarefa.')
        this.showNotification(message, 'red darken-2')
        this.loadingExecute = false
      })
      this.loadingExecute = false
    },
    async createDeleteTask() {
      this.loadingCreateDeleteTask = true
      await this.$store.dispatch('posts/createDeletionTask', this.taskData.entity.id)
        .then(res => {
          window.open(`/task/${res.data.task.id}`)
          this.showNotification(res.data.message, 'green darken-2')
        })
        .catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao criar a tarefa de exclusão.')
          this.showNotification(message, 'red darken-2')
          this.loadingCreateDeleteTask = false
        })
      this.loadingCreateDeleteTask = false
    },
    async cancelTask() {
      this.loadingCancel = true
      await this.$store.dispatch('tasks/cancel', this.id).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao cancelar a tarefa.')
        this.showNotification(message, 'red darken-2')
        this.loadingCancel = false
      })
      this.loadingCancel = false
    },
    onCancelTask() {
      this.$router.push('/tasks')
    },
    parseDate(date) {
      if (typeof date !== 'string') return ''
      return date.split(' ')[0]
    },
    parseTime(time) {
      if (typeof time !== 'string') return ''
      return time.split(' ')[1]
    },
    getBackground: function (media) {
      let contains = media.includes('mp4')
      if (contains)
        return backgroundVideoDefault

      return media
    }
  },
  watch: {
    task(task) {
      this.taskData = task
      console.log('task-data', task)
      const errorData = get(task, 'error_data')
      this.errorsCount = Array.isArray(errorData)
        ? errorData.length
        : errorData ? 1 : 0
      this.errorsLog = Array.isArray(errorData) ? errorData.map((e, i) => ({ ...e, error: true, _key: i })) : []
      this.errorMessage = this.errorsCount > 0
        ? get(task, 'error_log.message')
        : 'Nenhum erro encontrado.'
      this.errorData = errorData
    },
    locationsExport(blob, oldBlob) {
      if (blob && blob !== oldBlob) {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'locais.xlsx') //or any other extension
        document.body.appendChild(link)
        link.click()
      }
    }
  },
  created() {
    const id = this.$route.params.id
    if (!id) {
      this.showNotification('Nenhuma tarefa encontrada', 'red darken-2');
    } else {
      this.id = id
      this.getTask(id)
    }
  },
  data: () => ({
    loadingCreateDeleteTask: false,
    loadingDownload: false,
    loading: false,
    loadingExecute: false,
    loadingCancel: false,
    progress: 0,
    errorsCount: 0,
    errorMessage: '',
    errorData: '',
    logPage: 1,
    errorPage: 1,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    breadcrumb: [
      {
        text: 'Tarefas',
        disabled: false,
        href: '/tasks',
      },
      {
        text: 'Detalhes da tarefa',
        disabled: true,
        href: '',
      }
    ],
    tab: 'logs',
    tabs: [
      { name: 'status', title: 'Status' },
      { name: 'errors', title: 'Erros' },
      { name: 'local_post', title: 'Postagem' },
    ],
    taskData: {},
    firebaseData: {},
    statusTableHeaders: [
      {
        text: 'Origem',
        align: 'left',
        sortable: true,
        value: 'display_name',
      },
      {
        text: 'Mensagem',
        align: 'left',
        sortable: true,
        value: 'message',
      },
    ],
    logs: [],
    errorsLog: [],
  }),
  mounted() {
    const FB_DB_REF = process.env.VUE_APP_FIREBASE_DATABASE
    console.log('[DEBUG FIREBASE] Lendo do nó:', `${FB_DB_REF}/tasks/${this.id}`)
    const myRef = ref(database, `${FB_DB_REF}/tasks/${this.id}`)
    onValue(myRef, (snapshot) => {
      const data = snapshot.val()
      console.log('[DEBUG FIREBASE] Dados encontrados:', data)
      const logs = (get(data, 'logs') || {})
      const errorsLog = (get(data, 'errors_log') || {})

      this.firebaseData = data || {}

      // logs (STATUS) — key por índice evita "Duplicate keys" no v-data-table
      this.logs = Object.values(logs).reverse().map((l, i) => ({ ...l, _key: i }))

      // erros: só sobrescreve com o realtime se houver entradas — NÃO zera o que veio da API
      // (error_data). Erros de parsing do import não vão pro errors_log do Firebase, só pra API.
      const fbErrors = Object.values(errorsLog)
      if (fbErrors.length > 0) {
        this.errorsLog = fbErrors.reverse().map((e, i) => ({ ...e, error: true, _key: i }))
        this.errorsCount = fbErrors.length
      }

      // se o realtime indica que finalizou mas o estado carregado ainda não reflete,
      // re-busca a task (traz error_data + file_name) — evita depender de F5 manual
      const fbStatus = get(data, 'status')
      if ((fbStatus === 'ERROR' || fbStatus === 'OK') && this.taskData && this.taskData.status !== fbStatus) {
        this.getTask(this.id)
      }
    })
  }
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
}
</style>
